import React from 'react';
import SelectableCard from './SelectableCard.jsx';

const BADGE_VARIANTS = {
  gray: 'bg-gray-200 text-gray-800',
  teal: 'bg-teal-100 text-teal-800',
  indigo: 'bg-indigo-100 text-indigo-700',
};

export default function RadioCard({ name, value, checked, onChange, label, badge, badgeVariant = 'gray', description, meta, children }) {
  return (
    <SelectableCard name={name} value={value} checked={checked} onChange={onChange}>
      <span className="flex items-center gap-2 flex-wrap">
        <span className="font-medium text-gray-900">{label}</span>
        {badge && (
          <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${BADGE_VARIANTS[badgeVariant] || BADGE_VARIANTS.gray}`}>
            {badge}
          </span>
        )}
      </span>
      {description && <span className="block text-sm text-gray-500 mt-1">{description}</span>}
      {meta && meta.length > 0 && (
        <span className="block text-xs text-gray-500 mt-2">
          {meta.join(' · ')}
        </span>
      )}
      {children}
    </SelectableCard>
  );
}
